import {
    SET_ACTIVE_PANEL_TABS,
    SET_DASHBOARD_FILTERS,
    SET_LOADING_PANEL,
    SET_METRIC_DATA,
    SET_METRIC_DATA_LOADING,
    SET_VIEW_STATE_LOADING,
    SET_VIEW,
    SET_WIDGET_FILTERS,
} from './reducerConstants';

export function setDashboardFilters(
    dispatch,
    updatedTimeAndPrecision,
    updatedFilters,
    updatedWhereClauses,
    updatedRecordLimit
) {
    dispatch({
        type: SET_DASHBOARD_FILTERS,
        payload: {
            dashboardTimeAndPrecision: updatedTimeAndPrecision,
            dashboardFilterValues: updatedFilters,
            dashboardWhereClauses: updatedWhereClauses,
            dashboardRecordLimit: updatedRecordLimit,
        },
    });
}

export function setView(dispatch, formattedView) {
    document.title = formattedView.title;
    dispatch({
        type: SET_VIEW,
        payload: formattedView,
    });
}

export function setMetricData(
    dispatch,
    metricData,
    lastViewedTimestamps,
    viewKey,
    resetAllData
) {
    dispatch({
        type: SET_METRIC_DATA,
        payload: {
            metricData,
            resetAllData,
            lastViewedTimestamps: {
                ...lastViewedTimestamps,
                [viewKey]: Date.now(),
            },
        },
    });
}

export function setWidgetFilters(dispatch, widgets) {
    dispatch({
        type: SET_WIDGET_FILTERS,
        payload: widgets,
    });
}

export function setActivePanelTabs(dispatch, activePanelTabs) {
    dispatch({
        type: SET_ACTIVE_PANEL_TABS,
        payload: activePanelTabs,
    });
}

export function setMetricDataLoading(dispatch) {
    dispatch({ type: SET_METRIC_DATA_LOADING });
}

export function setIsViewStateLoading(dispatch) {
    dispatch({ type: SET_VIEW_STATE_LOADING });
}

export function setLoadingPanel(dispatch, loadingPanel) {
    dispatch({ type: SET_LOADING_PANEL, payload: loadingPanel });
}
